import { CATEGORIES, CATEGORIES_OPTIONS } from '@store/types'
import shortly from 'vuex-shortly'
import graphQL from '@graphQL'
import CategoriesQuery from '@graphQL/queries/Categories'

const state = {
  categories: []
}

const getters = {
  [CATEGORIES]: 'categories',
  [CATEGORIES_OPTIONS]: (state) => {
    const options = state.categories.map((category) => ({
      label: category.name,
      value: category.id
    }))
    options.unshift({
      label: 'Todas',
      value: undefined
    })
    return options
  }
}

const mutations = {
  [CATEGORIES]: 'categories'
}

const actions = {
  [CATEGORIES]: async ({ commit }) => {
    const response = await graphQL(CategoriesQuery)
    const categories = response.data.data.categories
    commit(CATEGORIES, categories)
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/categories.js